import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCookieStore = create(
  persist(
    (set, get) => ({
      // State
      cookiesAccepted: false,
      cookiesAcceptedAt: null,
      showCookieModal: true,

      // Actions
      acceptCookies: () => {
        set({ 
          cookiesAccepted: true, 
          cookiesAcceptedAt: new Date().toISOString(),
          showCookieModal: false  // Never show again after acceptance
        });
      },

      rejectCookies: () => {
        set({ 
          cookiesAccepted: false, 
          cookiesAcceptedAt: null,
          showCookieModal: false
        });
      },

      hideCookieModal: () => {
        set({ showCookieModal: false });
      },

      showCookieModalAgain: () => {
        set({ showCookieModal: true });
      },

      checkCookieStatus: () => {
        return get().cookiesAccepted;
      },

      clearCookieData: () => {
        set({ 
          cookiesAccepted: false, 
          cookiesAcceptedAt: null,
          showCookieModal: true
        });
      },
    }),
    {
      name: 'cookie-storage',
      partialize: (state) => ({ 
        cookiesAccepted: state.cookiesAccepted,
        cookiesAcceptedAt: state.cookiesAcceptedAt,
        showCookieModal: state.showCookieModal
      }),
    }
  )
);

export default useCookieStore;
